// Importa módulo de controle de rotas
import { createRouter, createWebHistory } from 'vue-router'

// Importa módulo de controle de autorização de login
import { useLoginStore } from '@/stores/loginStore'

// Importa módulo que controla as autorizações se está logado ou não
import { useAuthStore } from '@/stores/authStore'  // Para controle de login
    
import LoginForm from '../views/LoginForm.vue'

import ListaEmpresas from '../views/ListaEmpresas.vue'
import CadastroEmpresas from '../views/CadastroEmpresas.vue'

import ListaRamosAtividade from '../views/ListaRamosAtividade.vue'
import CadastroRamosAtividade from '../views/CadastroRamosAtividade.vue'

import ListaStatusCredito from '../views/ListaStatusCredito.vue'
import CadastroStatusCredito from '../views/CadastroStatusCredito.vue'

import ListaStatusNegociacao from '../views/ListaStatusNegociacao.vue'
import CadastroStatusNegociacao from '../views/CadastroStatusNegociacao.vue'

import ListaProdutos from '../views/ListaProdutos.vue'
import CadastroProdutos from '../views/CadastroProdutos.vue'

import ListaTiposChamados from '../views/ListaTiposChamados.vue'
import CadastroTiposChamados from '../views/CadastroTiposChamados.vue'

import ListaEmail from '../views/ListaEmail.vue'
import CadastroEmail from '../views/CadastroEmail.vue'

import ListaMensagens from '../views/ListaMensagens.vue'
import CadastroMensagens from '../views/CadastroMensagens.vue'

import CadastroChamados from '../views/CadastroChamados.vue'

import CadastroChamadosCliente from '../views/CadastroChamadosCliente.vue'

import CadastroNegociacoes from '@/views/CadastroNegociacoes.vue'

import ListaDepartamentos from '@/views/ListaDepartamentos.vue'
import CadastroDepartamentos from '@/views/CadastroDepartamentos.vue'

import ListaAvarias from '@/views/ListaAvarias.vue'
import CadastroAvarias from '@/views/CadastroAvarias.vue'

import ListaFabricantes from '@/views/ListaFabricantes.vue'
import CadastroFabricantes from '@/views/CadastroFabricantes.vue'

import ListaTipoEquipamento from '@/views/ListaTipoEquipamento.vue'
import CadastroTipoEquipamento from '@/views/CadastroTipoEquipamento.vue'

import ListaEquipamentos from '@/views/ListaEquipamentos.vue'
import CadastroEquipamentos from '@/views/CadastroEquipamentos.vue'

import LiberaEquipamentos from '@/views/LiberaEquipamentos.vue'

// Limpa indicação de autenticado no localStorage
//localStorage.setItem('autenticado', 'false')

// Define as rotas
const routes = [
    { 
        path: '/', 
        redirect: '/login' 
    },
    {
        path: '/login',
        name: 'Login',
        component: LoginForm
    },
    {
        path: '/lista-empresas',   // rota para brower chamar lista de empresas
        name: 'ListaEmpresas',
        component: ListaEmpresas,  // ✅ Apenas uma vez
        meta: { requiresAuth: true } // Rota protegida, requer autenticação
    },  
    {
        path: '/cadastro-empresas',   // rota para brower chamar cadastro de empresas
        name: 'CadastroEmpresas',
        component: CadastroEmpresas,
        meta: { requiresAuth: true } // Rota protegida, requer autenticação
    },  
    {
        path: '/lista-ramos-atividade',   // rota para brower chamar cadastro de ramos de atividade
        name: 'ListaRamosAtividade',
        component: ListaRamosAtividade,
        meta: { requiresAuth: true } // Rota protegida, requer autenticação 
    },  
    {
        path: '/cadastro-ramos-atividade',   // rota para brower chamar cadastro de ramos de atividade
        name: 'CadastroRamosAtividade',
        component: CadastroRamosAtividade,
        meta: { requiresAuth: true } // Rota protegida, requer autenticação
    },
    {
        path: '/lista-status-credito',   // rota para brower chamar cadastro de status de crédito
        name: 'ListaStatusCredito',
        component: ListaStatusCredito,
        meta: { requiresAuth: true } // Rota protegida, requer autenticação         
    },
    {
        path: '/cadastro-status-credito',   // rota para brower chamar cadastro de status de crédito
        name: 'CadastroStatusCredito',
        component: CadastroStatusCredito,
        meta: { requiresAuth: true } // Rota protegida, requer autenticação
    },
    {
        path: '/lista-status-cliente',   // rota para brower chamar cadastro status cliente
        name: 'ListaStatusNegociacao',
        component: ListaStatusNegociacao,
        meta: { requiresAuth: true } // Rota protegida, requer autenticação
    },
    {
        path: '/cadastro-status-negociacao',   // rota para brower chamar cadastro status cliente
        name: 'CadastroStatusNegociacao',
        component: CadastroStatusNegociacao,
        meta: { requiresAuth: true } // Rota protegida, requer autenticação
    },
    {
        path: '/lista-produtos',   // rota para brower chamar cadastro de produtos
        name: 'ListaProdutos',
        component: ListaProdutos,
        meta: { requiresAuth: true } // Rota protegida, requer autenticação
    },
    {
        path: '/cadastro-produtos',   // rota para brower chamar cadastro de produtos
        name: 'CadastroProdutos',
        component: CadastroProdutos,
        meta: { requiresAuth: true } // Rota protegida, requer autenticação
    },
    {
        path: '/lista-tipos-chamados',   // rota para brower chamar cadastro de tipos de chamado
        name: 'ListaTiposChamados',
        component: ListaTiposChamados,
        meta: { requiresAuth: true } // Rota protegida, requer autenticação
    },
    {
        path: '/cadastro-tipos-chamados',   // rota para brower chamar cadastro de tipos de chamado
        name: 'CadastroTiposChamados',
        component: CadastroTiposChamados,
        meta: { requiresAuth: true } // Rota protegida, requer autenticação
    },
    {
        path: '/lista-email',   // rota para brower chamar cadastro de e-mail
        name: 'ListaEmail',
        component: ListaEmail,
        meta: { requiresAuth: true } // Rota protegida, requer autenticação
    },
    {
        path: '/cadastro-email',   // rota para brower chamar cadastro de e-mail
        name: 'CadastroEmail',
        component: CadastroEmail,
        meta: { requiresAuth: true } // Rota protegida, requer autenticação
    },
    {
        path: '/lista-mensagens',   // rota para brower chamar cadastro de mensagens
        name: 'ListaMensagens',
        component: ListaMensagens,
        meta: { requiresAuth: true } // Rota protegida, requer autenticação
    },
    {
        path: '/cadastro-mensagens',   // rota para brower chamar cadastro de mensagens
        name: 'CadastroMensagens',
        component: CadastroMensagens,
        meta: { requiresAuth: true } // Rota protegida, requer autenticação
    },
    {
        path: '/lista-departamentos',
        name: 'ListaDepartamentos',
        component: ListaDepartamentos,
        meta: {requiresAuth: true}
    },
    {
        path: '/cadastro-departamentos',
        name: 'CadastroDepartamentos',
        component: CadastroDepartamentos,
        meta: {requiresAuth: true}
    },
    {
        path: '/lista-avarias',
        name: 'ListaAvarias',
        component: ListaAvarias,
        meta: {requiresAuth: true}
    },
    {
        path: '/cadastro-avarias',
        name: 'CadastroAvarias',
        component: CadastroAvarias,
        meta: {requiresAuth: true}
    },
    {
        path: '/lista-fabricantes',
        name: 'ListaFabricantes',
        component: ListaFabricantes,
        meta: {requiresAuth: true}
    },
    {
        path: '/cadastro-fabricantes',
        name: 'CadastroFabricantes',
        component: CadastroFabricantes,
        meta: {requiresAuth: true}
    },
    {
        path: '/lista-tipo-equipamento',
        name: 'ListaTipoEquipamento',
        component: ListaTipoEquipamento,
        meta: {requiresAuth: true}
    },
    {
        path: '/cadastro-tipo-equipamento',
        name: 'CadastroTipoEquipamento',
        component: CadastroTipoEquipamento,
        meta: {requiresAuth: true}
    },
    {
        path: '/lista-equipamentos',
        name: 'ListaEquipamentos',
        component: ListaEquipamentos,
        meta: {requiresAuth: true}
    },
    {
        path: '/cadastro-equipamentos',
        name: 'CadastroEquipamentos',
        component: CadastroEquipamentos,
        meta: {requiresAuth: true}
    },
    {
        path: '/cadastro-chamados',  // rota para brower chamar cadastro de chamados
        name: 'CadastroChamados',    // ✅ Adicione um nome para a rota
        component: CadastroChamados,  // ✅ Apenas uma vez
        meta: { requiresAuth: true } // Rota protegida, requer autenticação
    },
    {
        path: '/cadastro-chamados-cliente',  // rota para brower chamar cadastro de chamados dos clientes
        name: 'CadastroChamadosCliente',
        component: CadastroChamadosCliente,
        meta: { requiresAuth: true } // Rota protegida, requer autenticação
    },
    {
        path: '/cadastro-negociacoes',
        name: 'CadastroNegociacoes',
        component: CadastroNegociacoes,
        meta: { requiresAuth: true } // Rota protegida, requer autenticação
    },
    {
        path: '/libera-equipamentos',
        name: 'LiberaEquipamentos',
        component: LiberaEquipamentos,
        meta: { requiresAuth: true } // Rota protegida, requer autenticação
    }
]

// Cria o roteador
const router = createRouter({ 
    history: createWebHistory(),
    routes
})

/// Mova as stores para FORA do beforeEach
let loginStore, autorizacaoLogin

// Função para inicializar as stores (chamar uma vez)
function initializeStores() {
    if (!loginStore) {
        loginStore = useLoginStore()
        autorizacaoLogin = useAuthStore()
    }
}

// Adiciona um guardião global para verificar autenticação
router.beforeEach((to, from, next) => {

    initializeStores()
    
    // Verifica se a rota requer autenticação
    if (to.meta.requiresAuth) {

        // Verifica se está logado
        if (autorizacaoLogin.estaLogado) {

            // Verifica se a sessão expirou
            const expired = loginStore.checkSessionExpiry()
            
            // Se expirou, redireciona para login
            if (expired) {
              
                // Redireciona para login se expirado
                next('/login')
            
            } else {
            
                // Continua para a rota protegida
                next()
            }

        } else {

            // Redireciona para login se não está logado
            next('/login')
        }

    } else {

        // Se a rota não requer autenticação, continua
        next()
    }
})

export default router
